import React, { useContext, createContext, useState, useEffect } from "react";
import { deleteToken } from "utils/auth";
import { User } from "types/user";
import { useToast } from "hooks";
import { fetchMe } from "api/webservice/users";

export const defaultUser = {
  id: "",
  username: "",
  email: "",
  first_name: "",
  last_name: "",
  has_accepted_eula: false,
  privs: 0,
  coach_id: "",
  iat: 0,
  organization_id: "",
  createdAt: new Date(),
  updatedAt: new Date()
};

type UserContextType = {
  user: User;
  setUser: (user: User) => void;
};

const UserContext = createContext<UserContextType | undefined>(undefined);

export const useUser = () => {
  return useContext(UserContext);
};

type Props = {
  children: React.ReactNode;
};

export const UserProvider = ({ children }: Props) => {
  const [user, setUser] = useState(defaultUser);
  const toast = useToast();

  useEffect(() => {
    fetchMe()
      .then(updateUser => {
        setUser(updateUser);
      })
      .catch(err => {
        // if it's not a timeout or network error, delete the token
        if (err.response?.status >= 400 &&
          err.response?.status < 500) {
          deleteToken();
          // 419 is a token expiration error
          if (err.response?.status == 419) {
            toast({
              title: "Your session has expired",
              description: "Please log in again.",
              status: "warning"
            });
          }
        }

        // redirect them to the login page if they aren't already there
        if (window.location.pathname !== "/login") window.location.assign("/login");
        return;
      });
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
